import { InstalltionFormSteps } from '../../providers/InstallationFormProvider';
export const InstallationJobStepsList: {id: number, label: string}[] = [
    {id: InstalltionFormSteps.CHOOSE_LOCATION, label: "Location Selection"},
    {id: InstalltionFormSteps.MACHINE_SETUP, label: "Machine Setup"},
    {id: InstalltionFormSteps.MACHINE_DATA, label: "Machine Data"},
    {id: InstalltionFormSteps.CREATE_TICKET, label: "Create Ticket"},
    {
      id: InstalltionFormSteps.LOCATION_INFORMATION,
      label: "Location Information",
    },
    {id: InstalltionFormSteps.LOCATION_CONTACTS, label: "Location Contacts"},
    {id: InstalltionFormSteps.PICTURES_AND_VIDEO, label: "Location Notes"},
    {id: InstalltionFormSteps.SUBMIT, label: "Submit"},
  ];